import React, { useContext, useEffect } from "react";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import AuthContext from "../../store/auth-context";
import Transactions from "../../resources/icons/folder-favorite.svg";
import TransactionsCurrent from "../../resources/icons/folder-favoriteCurrent.svg";
import Verify from "../../resources/icons/brush.svg";
import VerifyCurrent from "../../resources/icons/brushCurrent.svg";
import VpIcon from "../../resources/icons/id-card.svg";
import AppConstants from "../../configs/AppConstants";
import useSidebarNavigation from "../../hooks/useSidebarNavigation";

const MobileNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  const handleIssuedClick = (e) => {
    e.preventDefault();
    authContext.IssuedOffsetHandler(0);
    localStorage.setItem("transactionOffset", 0);
    navigate("/verifier/transaction/all");
  };

  const allNavItems = {
    Verify: {
      navId: "mobile-nav-verify-nav-link",
      name: "Verify",
      to: "/verifier/validate",
      match: {
        type: "partial",
        path: "/verifier/validate",
      },
      icon: Verify,
      currentNavIcon: VerifyCurrent,
      iconClasses: "w-6",
      allowedRoles: ["admin", "admin_verifier", "verifier"],
    },
    Transactions: {
      navId: "mobile-nav-transactions-nav-link",
      name: "Transactions",
      to: "/verifier/transaction/all",
      match: {
        type: "partial",
        path: "/verifier/transaction/",
      },
      icon: Transactions,
      currentNavIcon: TransactionsCurrent,
      iconClasses: "w-6",
      onClick: handleIssuedClick,
      allowedRoles: ["admin", "admin_verifier", "verifier"],
    },
    Request: {
      navId: "mobile-nav-request-nav-link",
      name: "Request",
      to: "/verifier/vp/category",
      match: {
        type: "partial",
        path: "/verifier/vp/",
      },
      icon: VpIcon,
      currentNavIcon: VpIcon,
      iconClasses: "w-6",
      allowedRoles: ["admin", "admin_requester"],
    },
  };

  const isIIITB = AppConstants.TRUSTED_IIITB_HOSTS.includes(
    window.location.origin
  );

  const { sidebarComponents, fetchCurrentUser } =
    useSidebarNavigation(allNavItems);

  useEffect(() => {
    if (authContext.isLoggedIn) {
      fetchCurrentUser();
    }
  }, [authContext.isLoggedIn]);

  const filteredNavs = (Array.isArray(sidebarComponents) ? sidebarComponents : [])
    .filter(
      (key) =>
        allNavItems[key] &&
        allNavItems[key].allowedRoles.includes(authContext.userType)
    )
    .map((key) => allNavItems[key]);

  const finalNavs = filteredNavs;

  return (
    <div className="flex gap-3 h-full bg-cfSecondary overflow-y-auto items-center w-full border-t-[1.5px]">
      <div className="w-full flex items-start font-CfSecondaryFont gap-y-4">
        {finalNavs.map(
          (
            { name, to, match, icon, iconClasses, currentNavIcon, onClick, navId },
            index
          ) => (
            <>
              <NavLink
                id={navId}
                key={name}
                to={to}
                title={name}
                className={`flex w-full font-CfPrimaryFont text-sm capitalize py-2 bg-opacity-40 hover:text-cfPrimaryLight hover:no-underline`}
                onClick={onClick}
              >
                <div
                  className={`w-full flex flex-col items-center gap-3 justify-center ${
                    ((match.type === "exact" &&
                      location.pathname === match.path) ||
                      (match.type === "partial" &&
                        location.pathname.startsWith(match.path))) &&
                    "font-semibold text-cfPrimary"
                  }`}
                >
                  <img
                    src={
                      (match.type === "exact" &&
                        location.pathname === match.path) ||
                      (match.type === "partial" &&
                        location.pathname.startsWith(match.path))
                        ? currentNavIcon
                        : icon
                    }
                    alt=""
                    className={iconClasses}
                  />
                  {name}
                </div>
              </NavLink>
            </>
          )
        )}
      </div>
    </div>
  );
};

export default MobileNav;
